import clsx from "clsx"
import { useAuth } from "../../../modules/auth"

import { useEffect, useState } from "react"
import { useLazyReadMultipleQuery } from "../../../framework/services/data/tableDataApi"
import { FieldFilterType } from "../../../framework/base/types"

interface IGatePassHistory {
    name?: string,
    createdOn?: Date
}

export const useGetFullName = () => {
    const { user, siteId } = useAuth()
    const [getRecords] = useLazyReadMultipleQuery()
    const [records, setRecords] = useState<IGatePassHistory[]>([])

    useEffect(() => {
        if (!user?.contactId)
            return;

        getHistory()
        // eslint-disable-next-line
    }, [user])

    const getHistory = (): Promise<IGatePassHistory[]> => {
        if (!user?.contactId) {
            return Promise.reject('User contact not found.')
        }

        return getRecords({
            userId: user?.contactId || '',
            portalId: siteId || '',
            tableId: "contact",
            fieldList: ["fullname"],
            filters: [{
                group: 0, filters: [
                    { field: "contactid", type: FieldFilterType.Const, value: user.contactId }]
            }]
        })
            .unwrap()
            .then((data) => {
                const records = data.records.map<IGatePassHistory>(p => ({
                    name: p["fullname"]
                }))

                setRecords(records)
                return Promise.resolve(records);
            })
    }

    return { data: records }
}

export const SiteTitle = ({ className }: { className?: string }) => {
    const { site } = useAuth()
    const { data } = useGetFullName()
    const name = data?.[0]?.name
    const caption = `Welcome to the ${site?.title || 'Portal Framework'} ${name || ''}`

    return <div className={clsx(className)}>
        <div className='d-flex align-items-center '>
            <h1 className='my-1 fw-bolder'>{caption}</h1>
        </div>
    </div>
}